import { useRef, useState } from "react";
import { Play } from "lucide-react";

// Rich, unscripted — his real voice, no AI. Portrait clip recorded by Rich himself.
export const RichTalking = () => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);

  const start = () => {
    const v = ref.current;
    if (!v) return;
    v.muted = false;
    v.play().then(() => setPlaying(true)).catch(() => {});
  };

  return (
    <div className="mb-16 md:mb-24 grid grid-cols-12 gap-y-8 gap-x-8 items-center" data-testid="rich-talking">
      <div className="col-span-12 md:col-span-4 md:col-start-2">
        <div className="relative aspect-[9/16] max-h-[640px] mx-auto overflow-hidden border border-[#E7DFD5] bg-black group">
          <video
            ref={ref}
            src="/videos/rich_talking.mp4"
            poster="/videos/rich_talking.jpg"
            preload="metadata"
            playsInline
            controls={playing}
            onEnded={() => setPlaying(false)}
            onPause={() => setPlaying(false)}
            onPlay={() => setPlaying(true)}
            className="absolute inset-0 w-full h-full object-cover"
            data-testid="rich-talking-video"
          />
          {!playing && (
            <button
              onClick={start}
              data-testid="rich-talking-play"
              aria-label="Play Rich talking"
              className="absolute inset-0 flex items-center justify-center bg-black/30 hover:bg-black/20 transition-colors"
            >
              <span className="w-20 h-20 rounded-full bg-[#F59E0B] text-black flex items-center justify-center shadow-[0_0_60px_rgba(245,158,11,0.45)] group-hover:scale-105 transition-transform duration-500">
                <Play size={28} fill="currentColor" className="ml-1" />
              </span>
            </button>
          )}
        </div>
      </div>
      <div className="col-span-12 md:col-span-6 md:col-start-7">
        <div className="section-tag mb-4">§ Rich, in his own voice</div>
        <h3 className="font-display text-3xl md:text-4xl lg:text-5xl leading-[0.95] tracking-tight mb-6">
          &ldquo;The pain of change is temporary. The pain of staying the same is <span className="italic text-[#B45309]">permanent</span>.&rdquo;
        </h3>
        <p className="text-[#78716C] text-base md:text-lg leading-relaxed max-w-xl" data-testid="rich-talking-caption">
          Ninety seconds, unscripted, no AI — Rich reading from the T.A.C.C. Manual on the lie <em>&ldquo;I don&apos;t know how to change&rdquo;</em>, and the one-thing-a-day rule that turns into 365 changes a year.
        </p>
        <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B45309] mt-6">Real voice · Real face · 1:37</div>
      </div>
    </div>
  );
};
